import {QueryParams, useCall} from '@usedapp/core';
import {
    Awaited,
    ContractMethodNames,
    Falsy,
    TypedContract,
} from '@usedapp/core/dist/esm/src/model/types';
import {Call} from '@usedapp/core/dist/esm/src/hooks/useCall';

import useShowError from './useShowError';

export default function useContractRead<
    T extends TypedContract,
    MN extends ContractMethodNames<T>,
>(
    // @ts-ignore
    call: Call<T, MN> | Falsy,
    queryParams: QueryParams = {},
): [
    Awaited<ReturnType<T['functions'][MN]>>[0] | undefined,
    boolean,
    Error | undefined,
] {
    // @ts-ignore
    const {value, error} = useCall(call, queryParams) ?? {};
    useShowError(error);
    return [value?.[0], !value, error];
}
